<template>
  <AiPrinciples />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AiPrinciples from "../../components/Apps/AiPrinciples/index.vue";

export default defineComponent({
  name: "AiPrinciplesPage",
  components: {
    AiPrinciples,
  },
});
</script>
